import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InfoStatusEnum } from '../../../enums/infoStatus.enum'

@Component({
  selector: 'app-soc-input-field',
  templateUrl: './soc-input-field.component.html',
  styleUrls: ['./soc-input-field.component.scss']
})
export class SocInputFieldComponent implements OnInit {

  @Input() label: string | null;
  @Input() alertLabel: string | null;
  @Input() status: InfoStatusEnum = InfoStatusEnum.Info;
  @Input() placeholder: string;
  @Input() disabled: boolean = false;
  @Input() input: any = "";
  @Output() inputChange = new EventEmitter<any>();

  public infoStatusEnum = InfoStatusEnum;

  constructor() {
   }

  ngOnInit(): void {
  }

}
